module.exports = __webpack_public_path__ + "proximanova-bold-webfont.59b54bb47d21e6221fab.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/sherr/Desktop/bsf-website/src/assets/fonts/proximanova-bold-webfont.woff
// module id = ../../../../../src/assets/fonts/proximanova-bold-webfont.woff
// module chunks = 1